import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Actividad, Error } from '@rpe/registro-personas-empresas-lib';

// LOAD
export const entityActividadesLoadRequest = createAction(
  '[ENTITYACTIVIDADES] Load Request'
);

export const entityActividadesLoadFailure = createAction(
  '[ENTITYACTIVIDADES] Load Failure',
  props<{ error: Error }>()
);

export const entityActividadesLoadSuccess = createAction(
  '[ENTITYACTIVIDADES] Load Success',
  props<{ items: Actividad[] }>()
);

// ADD
export const entityActividadesAddRequest = createAction(
  '[ENTITYACTIVIDADES] Add Request',
  props<{ item: any }>()
);

export const entityActividadesAddFailure = createAction(
  '[ENTITYACTIVIDADES] Add Failure',
  props<{ error: Error }>()
);

export const entityActividadesAddSuccess = createAction(
  '[ENTITYACTIVIDADES] Add Success',
  props<{ item: any }>()
);

//actividad
export const entityActividadAddRequest = createAction(
  '[ENTITYACTIVIDADES] Add Request',
  props<{ item: Actividad }>()
);

export const entityActividadAddFailure = createAction(
  '[ENTITYACTIVIDADES] Add Failure',
  props<{ error: Error }>()
);

export const entityActividadAddSuccess = createAction(
  '[ENTITYACTIVIDADES] Add Success',
  props<{ item: Actividad }>()
);

// CHANGE
export const entityActividadesChangeRequest = createAction(
  '[ENTITYACTIVIDADES] Change Request',
  props<{ item: Actividad }>()
);

export const entityActividadesChangeFailure = createAction(
  '[ENTITYACTIVIDADES] Change Failure',
  props<{ error: Error }>()
);

export const entityActividadesChangeSuccess = createAction(
  '[ENTITYACTIVIDADES] Change Success',
  props<{ item: Update<Actividad> }>()
);

// DELETE
export const entityActividadesDeleteRequest = createAction(
  '[ENTITYACTIVIDADES] Delete Request',
  props<{ item: Actividad }>()
);

export const entityActividadesDeleteFailure = createAction(
  '[ENTITYACTIVIDADES] Delete Failure',
  props<{ error: Error }>()
);

export const entityActividadesDeleteSuccess = createAction(
  '[ENTITYACTIVIDADES] Delete Success',
  props<{ item: Actividad }>()
);
